import dayjs from "dayjs";
import { LRUCache } from "lru-cache";
//#region src/utils/date-time/format-time-for-humanoids.ts
var cache = new LRUCache({ max: 1e3 });
function formatTimeForHumanoids(time, show24Hr = false) {
	if (!time) return "";
	let hour;
	let minute;
	if (typeof time === "string") {
		const djs = dayjs(time);
		hour = djs.get("hour");
		minute = djs.get("minute");
	} else if ("format" in time) {
		hour = time.get("hour");
		minute = time.get("minute");
	} else {
		hour = time.hour;
		minute = time.minute;
	}
	const cacheKey = `${hour}:${minute}:${show24Hr}`;
	if (cache.get(cacheKey)) return cache.get(cacheKey);
	try {
		let minFormatted;
		if (minute === 0) {
			if (show24Hr) minFormatted = "00";
			else minFormatted = "";
		} else if (minute < 10) minFormatted = minute.toString().padStart(2, "0");
		else minFormatted = minute.toString();
		if (show24Hr) {
			const returnVal = `${hour}:${minFormatted}`;
			cache.set(cacheKey, returnVal);
			return returnVal;
		}
		const hourFormatted = hour % 12 || 12;
		const ampm = hour >= 12 ? "p" : "a";
		const returnVal = `${hourFormatted}${minFormatted ? `:${minFormatted}` : ""}${ampm}`;
		cache.set(cacheKey, returnVal);
		return returnVal;
	} catch (err) {
		console.warn(`formatTimeForHumanoids("${time}") errored`, err);
		return "";
	}
}
//#endregion
export { formatTimeForHumanoids };

//# sourceMappingURL=format-time-for-humanoids.js.map